import React, { useEffect } from 'react';
import { Box } from '@atlaskit/primitives';
import { useRightSidebarController } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import { useIsCollectionView } from '@atlassian/jira-polaris-component-environment/src/PolarisEnvironmentProvider.tsx';
import { ProjectTemplateEnum } from '@atlassian/jira-polaris-domain-project/src/types.tsx';
import { OnboardingCheckList } from './OnboardingCheckList.tsx';

const QUICKSTART_PANEL_ID = 'jpd-quickstart';
const QUICKSTART_PANEL_WIDTH = 365;

export const useQuickstartPanel = ({
	projectInitialTemplate,
}: {
	projectInitialTemplate: string | undefined;
}) => {
	const { openRightSidebar, closeRightSidebar } = useRightSidebarController();
	const isCollectionView = useIsCollectionView();

	useEffect(() => {
		if (
			isCollectionView ||
			!projectInitialTemplate ||
			projectInitialTemplate === ProjectTemplateEnum.BLANK
		) {
			return;
		}

		openRightSidebar(QUICKSTART_PANEL_ID, QUICKSTART_PANEL_WIDTH, false, true);

		return () => {
			closeRightSidebar(QUICKSTART_PANEL_ID);
		};
	}, [closeRightSidebar, isCollectionView, openRightSidebar, projectInitialTemplate]);
};

const taskDictionary = {
	'task-1': {
		id: 'task-1',
		title: 'Task 1',
		children: <Box>Task 1 description</Box>,
	},
};

export const QuickstartPanel = () => <OnboardingCheckList taskDictionary={taskDictionary} />;
